import Intro from "./scenes/intro/Intro.js";
import Candle from "./scenes/Cand/Candle.js";
import MakeACake from "./scenes/MakeACake/MakeACake.js";
import EndCake from "./scenes/MakeACake/EndCake.js";
import MakeACakePlacer from "./scenes/MakeACake/MakeACakePlacer.js";


export default {
    scenes: [
        Intro, //Here you can add new scenes on the fly
         Candle,
         MakeACake,
         MakeACakePlacer,
         EndCake
    ],
    startScene: Intro.KEY,
    // startScene: Candle.KEY,
    // startScene: MakeACake.KEY,
    // startScene: MakeACakePlacer.KEY,

    spines: [], //Place the name of the spine file here, excluding the extension
    isDev: false,
    gameMuted: false,
    bgMusic: "",
    CakeTint: 0xffffff,
}
